module.exports = __webpack_public_path__ + "static/media/uosgy_mobile_bottom.5d23cb3f.jpg";